import { IRemoveTagsOptions } from './removeTags.types';

const TAGS_FOR_REMOVE = ['*', '**', '***', '~~', '__', '```', '[', ']'];

export const removeTags = ({ text, positionToTag }: IRemoveTagsOptions): string => {
  const tags = Object.values(positionToTag);

  let startPosition = 0;
  let updatedText = '';

  for (let i = 0; i < tags.length; i++) {
    const item = tags[i];

    if (item.tag && !TAGS_FOR_REMOVE.includes(item.tag)) {
      continue;
    }

    if (startPosition < item.start) {
      const substring = text.substring(startPosition, item.start);
      updatedText += substring;
    }

    startPosition = item.end;
  }

  if (startPosition < text.length) {
    const substring = text.substring(startPosition);
    updatedText += substring;
  }

  return updatedText;
};
